import { useLocation, Navigate } from 'react-router-dom';

/**
 * SF-162 Component 6: replaces the deleted `Council.tsx` as the `/council` route's element.
 * Replicates `Council.tsx`'s exact 3-branch render-time hash logic verbatim — preserving the 8
 * hash-based deep links SF-160 (`#buildings`) and SF-164 (the economy family) shipped, rather than
 * silently dropping them behind an unconditional redirect (Phase 3 Decision 1, resolves Phase 2's
 * unanimous Critical Issue).
 *
 * A pure `useLocation().hash` → `<Navigate>` decision — no province fetch, no loading/error gates,
 * same as the source branches in `Council.tsx` were before this page's Military/Military Power
 * content was absorbed into `Training.tsx`'s Overview tab (SF-162).
 */
const ECONOMY_REDIRECT_HASHES = ['#economy', '#flows', '#gold', '#food', '#runes', '#overview', '#affairs-of-state'];

export function CouncilRedirect() {
  const location = useLocation();

  if (location.hash === '#buildings') {
    return <Navigate to="/buildings?tab=overview" replace />;
  }

  if (ECONOMY_REDIRECT_HASHES.includes(location.hash)) {
    return <Navigate to="/economy" replace />;
  }

  // Every other legacy hash (`#military`, `#troops`, `#military-affairs`, `#science`, `#mystic`,
  // `#mystic-affairs`, `#spells`, or no hash at all) falls through here — matching `Council.tsx`'s
  // own fall-through behavior, just landing on the Overview tab (via the read-only `?tab=` seed on
  // `Training.tsx`, Component 2) instead of re-rendering Military/Military Power tabs locally.
  return <Navigate to="/military?tab=overview" replace />;
}
